import dynamic from "next/dynamic";

export const SectorSkills = dynamic(() => import("./component"));
